module.exports = __webpack_public_path__ + "img/logo_news_techkorea@4x.7a88ea5d.png";